import ApplicationLayout from '@rio-cloud/rio-uikit/ApplicationLayout';
import NotificationsContainer from '@rio-cloud/rio-uikit/NotificationsContainer';
import useEffectOnce from '@rio-cloud/rio-uikit/useEffectOnce';
import { FlagsProvider } from 'react-feature-flags';
import { IntlProvider } from 'react-intl';
import { Outlet, useLocation } from 'react-router';
import { ROUTE } from '../../common/constants';
import { config } from '../../configuration/config';
import { useAppDispatch, useAppSelector } from '../../configuration/setup/hooks';
import { useFeatureToggles } from '../../hooks/useFeatureToggles';
import { useWidgetListener } from '../../hooks/widgetHooks';
import { DefaultRedirect } from '../../routes/DefaultRedirect';
import { registerSearchWidget } from '../../store/app/appSlice';
import { useGetAccountSubscriptionInfoQuery } from '../../store/facade/facadeApiV2';
import { selectDisplayMessages, selectLocale } from '../../store/lang/langSelectors';
import { sendMessage } from '../../store/widget/widgetServices';
import { widgetActions } from '../../store/widget/widgetSlice';

export const AppLayout = () => {
    const userLocale = useAppSelector(selectLocale);
    const displayMessages = useAppSelector(selectDisplayMessages);
    const location = useLocation();
    const dispatch = useAppDispatch();
    const { featureFlags } = useFeatureToggles();
    useWidgetListener();

    useEffectOnce(() => {
        if (location.pathname === ROUTE.SEARCH_ROUTE) {
            dispatch(registerSearchWidget());
        }
        sendMessage(widgetActions.widgetLoaded());
    });

    useGetAccountSubscriptionInfoQuery();

    return (
        <IntlProvider
            defaultLocale={config.login.defaultLocale}
            key={userLocale}
            locale={userLocale ?? config.login.defaultLocale}
            messages={displayMessages}
        >
            <FlagsProvider value={featureFlags}>
                <ApplicationLayout data-testid='app-layout'>
                    <NotificationsContainer />
                    <Outlet />
                    <DefaultRedirect />
                </ApplicationLayout>
            </FlagsProvider>
        </IntlProvider>
    );
};
